import { useStore } from 'effector-react'
import { CreateForm } from '~/entities/Penalty'
import { formSubmitted, createFx } from './model'

export const AddPenalty = () => {
  const isSubmitting = useStore(createFx.pending)

  return <CreateForm isSubmitting={isSubmitting} onSuccess={formSubmitted} />
}
